{
  "el": {
    "pagination": {
      "previous": "Προηγούμενη σελίδα",
      "next": "Επόμενη σελίδα",
      "page_report": "Σελίδα {page} από {total}",
      "report": "Εμφάνιση {first} έως {last} από {total}",
      "total": "Σύνολο στοιχείων: {total}"
    }
  }
}
